import { ActionToast, type ToastComponent } from '@opallabs/lapidary'

type RescheduleToastProps = {
  /** The item moved, but the moment around it did not grow to cover it. */
  hasUnstretchedMoment?: boolean
  onUndo: () => void
  /** What moved. */
  title: string
  /** Where it landed, already written out for a person to read. */
  to: string
}

/**
 * Says what moved and offers to put it back. Undo is the only way back from a
 * drag: nothing else on the calendar remembers where the item was.
 */
export const RescheduleToast: ToastComponent<RescheduleToastProps> = ({
  hasUnstretchedMoment,
  onUndo,
  title,
  to,
  ...toastProps
}) => (
  <ActionToast
    {...toastProps}
    actionText="Undo"
    actionType="secondary"
    message={
      hasUnstretchedMoment
        ? `"${title}" moved to ${to}. Its moment still ends before it.`
        : `"${title}" moved to ${to}.`
    }
    title={
      hasUnstretchedMoment
        ? 'Moved, but its moment could not be extended'
        : 'Moved'
    }
    onActionClick={onUndo}
  />
)
RescheduleToast.displayName = 'Calendar: RescheduleToast'
